import $ from 'jquery';
import _ from 'underscore';
import screenSize from '../services/screen_size';

export default function () {
    const isWatch = $('.-watch');

    // Do not autoplay when on mobile and Watch pages.
    if (screenSize.getSize() !== 'small' && isWatch.length === 0) {
        $(function () {
            // List of video ids to put in cache to keep track of state
            var cachedVideoIds = {};

            // Cache some DOM elements
            const $iframes = $('iframe[src*="/embed/"]');
            const $window = $(window);
            const $doc = $(document);

            // Dev replace video embeds with local url, because locally all the video embeds are on www.fastcompany.com, this will make it localhost instead
            $('iframe[src*="www.fastcompany.com/embed"]').each(function () {
                const $this = $(this);
                let src = $this.attr('src');
                src = src.match(/\.com/) ? src.split('.com')[1] : src.split('8880')[1];
                $this.attr('src', src);
            });

            // Define a function to call, with throttle to check video position and apply appropriate actions when scrolling.
            function _onScroll() {
                // check if the iframe DOM in cache is the same as the current iframe, if it's not, then end here
                if (!$iframes.length) {
                    return;
                }

                const winHeight = $window.height();
                const scrollTop = $doc.scrollTop();

                // Find all iframes in view and apply autoplay logic to it
                $iframes.each(function () {
                    const $this = $(this);
                    if ($($this.parent()[0]).hasClass('poster-wrapper')) {
                        return;
                    }
                    const height = $this.height();
                    const offset = $this.offset().top;
                    const src = $this.attr('src');
                    const disableInlineAutoPlay = $this.data('disableinlineautoplay');

                    // If the iframe has disable autoinline autoplay as a data attribute, then end it here
                    if (disableInlineAutoPlay === true) {
                        return;
                    }

                    let id = (src.match(/embed\/(.+)\?/)) ? src.match(/embed\/(.+)\?/)[1] : '';

                    // Store current id in a cache if it doesn't exist
                    if (!cachedVideoIds.originalId) {
                        cachedVideoIds.originalId = id;
                    } else if (cachedVideoIds.originalId === id) {
                        // Should update the cached Video Ids that matches current iframe
                        if (cachedVideoIds.newId) {
                            // Set the id to be whatever's in the cache
                            // video in the cache may be updated by player's playNext event
                            id = cachedVideoIds.newId;
                        }
                    }

                    let data = {};
                    // Find videos outside of view and pause them
                    if (offset < scrollTop || scrollTop + winHeight < offset + height) {
                        data.command = `pause:${id}`;
                    } else {
                        data.command = `play:${id}`;
                    }

                    $this[0].contentWindow.postMessage(data, '*');
                });
            }

            // Source: https://davidwalsh.name/window-iframe
            const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
            const eventer = window[eventMethod];
            const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

            // Listen to message from child window
            eventer(messageEvent, function (e) {
                if (e.data.name === 'playListNext') {
                    onNextVideo(e.data.nextVideo);
                } else if (e.data.name === 'disableInlineAutoplay') {
                    disableInlineAutoplay(e.data.videoID);
                }
            }, false);

            // When the video is about to play the next video in queue
            function onNextVideo(playListInfo) {
                if (cachedVideoIds.originalId) {
                    cachedVideoIds.newId = playListInfo.nextVideoId;
                }
            }

            // When the message is to stop the autoplay
            function disableInlineAutoplay(videoId) {
                // When the user clicks pause on the player itself, we should disable auto inline play
                _.each($iframes, (iframe) => {
                    let id = $(iframe).attr('src').match(/embed\/(.+)\?/)[1];
                    if (id === videoId) {
                        $(iframe).attr('data-disableinlineautoplay', 'true');
                    }
                });
            }

            $window.bind('scroll', _.throttle(_onScroll, 300));
        });
    }
}
